<div class="page">
  <h3>
    Пользователи ( {{users.length}} )
  </h3>
  <ng2-smart-table [settings]="settings" [source]="users"></ng2-smart-table>
</div>
